export default __webpack_public_path__ + "static/media/approch2.ae95df38.jpg";